import { ApiRegion, Region } from '@/features/destinations/utils/Region';

export const destinationRegionLabelMapper: { [key in ApiRegion]: Region } = {
  [ApiRegion.AfricaNorth]: Region.AfricaNorth,
  [ApiRegion.AfricaSafariEastSouthern]: Region.AfricaSafariEastSouthern,
  [ApiRegion.ArcticAntarctica]: Region.ArcticAntarctica,
  [ApiRegion.AsiaEast]: Region.AsiaEast,
  [ApiRegion.AsiaSouth]: Region.AsiaSouth,
  [ApiRegion.AsiaSoutheast]: Region.AsiaSoutheast,
  [ApiRegion.AustraliaAndNewZealand]: Region.AustraliaAndNewZealand,
  [ApiRegion.Canada]: Region.Canada,
  [ApiRegion.CaribbeanEasternSouthern]: Region.CaribbeanEasternSouthern,
  [ApiRegion.CaribbeanWestern]: Region.CaribbeanWestern,
  [ApiRegion.CentralAmerica]: Region.CentralAmerica,
  [ApiRegion.EuropeanEastern]: Region.EuropeanEastern,
  [ApiRegion.EuropeanMediterranean]: Region.EuropeanMediterranean,
  [ApiRegion.EuropeanUKAndIreland]: Region.EuropeanUKAndIreland,
  [ApiRegion.EuropeanWesternNorthern]: Region.EuropeanWesternNorthern,
  [ApiRegion.Mexico]: Region.Mexico,
  [ApiRegion.MiddleEast]: Region.MiddleEast,
  [ApiRegion.SouthAmerica]: Region.SouthAmerica,
  [ApiRegion.SouthPacific]: Region.SouthPacific,
  [ApiRegion.Unknown]: Region.Unknown,
  [ApiRegion.Alaska]: Region.Alaska,
  [ApiRegion.Hawaii]: Region.Hawaii,
  [ApiRegion.USAMainland]: Region.USAMainland,
};

export const getDestinationRegionLabel = (name: string): string =>
  destinationRegionLabelMapper[name as ApiRegion] ?? name;
